const jwtDecoder = (token) => {
  if (token != null && token !== undefined && token != "null") {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    var decoded = JSON.parse(atob(base64));

    return decoded;
  } else {
    return null;
  }
};

export { jwtDecoder };
